import React from "react";
import { Link } from "gatsby";
import { DropDown, DropDownList, DropDownListItem, DropDownSubList, DropDownSubItem, LinkStatic, DropdownFooter } from "./dropdown";

function MetalBuildingsDropdown({ isActive }) {
  // const {
  //   allContentfulProductCategories: { edges: categories },
  // } = useStaticQuery(
  //   graphql`
  //     query {
  //       allContentfulProductCategories(
  //         filter: { title: { ne: "Metal Buildings" } }
  //         sort: { fields: categoryOrder }
  //       ) {
  //         edges {
  //           node {
  //             title
  //             url
  //           }
  //         }
  //       }
  //     }
  //   `
  // );
  

  return (
    <DropDown className={`dropdown-menu dropdown-mega-menu  ${isActive ? "active" : ""}`}>
      <DropDownList className="dropdown-mega-list">
        <>
          <DropDownListItem>
            <Link to="/metal-garages/">Garages</Link>
            <DropDownSubList>
              <DropDownSubItem><Link to="/one-car-garages/">One Car Garages</Link></DropDownSubItem>
              <DropDownSubItem><Link to="/two-car-garages/">Two Car Garages</Link></DropDownSubItem>
              <DropDownSubItem><Link to="/three-car-garages/">Three Car Garages</Link></DropDownSubItem>
            </DropDownSubList>
          </DropDownListItem>          

          <DropDownListItem>
            <Link to="/metal-carports/">Carports</Link>
            <DropDownSubList>
              <DropDownSubItem><Link to="/one-car-carports/">One Car Carports</Link></DropDownSubItem>
              <DropDownSubItem><Link to="/two-car-carports/">Two Car Carports</Link></DropDownSubItem>
              <DropDownSubItem><Link to="/three-car-carports/">Three Car Carports</Link></DropDownSubItem>
              <DropDownSubItem><Link to="/rv-carports/">RV Carports</Link></DropDownSubItem>
            </DropDownSubList>
          </DropDownListItem>

          <DropDownListItem>
            <Link to="/metal-barns/">Barns</Link>            
            <DropDownSubList>
              <DropDownSubItem><Link to="/horse-barns/">Horse Barns</Link></DropDownSubItem>
            </DropDownSubList>
          </DropDownListItem>

          <DropDownListItem>
            <LinkStatic>Other Buildings</LinkStatic>
            <DropDownSubList>
              <DropDownSubItem><Link to="/metal-sheds/">Sheds</Link></DropDownSubItem>
              <DropDownSubItem><Link to="/utility-buildings/">Utility Buldings</Link></DropDownSubItem>
              <DropDownSubItem><Link to="/commercial-buildings/">Commercial Buildings</Link></DropDownSubItem>
              <DropDownSubItem><Link to="/workshop-buildings/">Workshops</Link></DropDownSubItem>
              <DropDownSubItem><Link to="/warehouse-buildings/">Warehouses</Link></DropDownSubItem>
              <DropDownSubItem><Link to="/storage-buildings/">Storage Buildings</Link></DropDownSubItem>
              
            </DropDownSubList>
          </DropDownListItem>
        </>
        {/* {categories.map((item, i) => {
          //const url = item.node.title.split(" ").join("-").toLowerCase();
          return (
            <DropDownListItem key={i}>
              <Link to={item.node.url}>{item.node.title}</Link>
            </DropDownListItem>
          );
        })} */}
      </DropDownList>
      <DropdownFooter><Link to="/prices/">Metal Building Prices</Link></DropdownFooter>
    </DropDown>
  );
}

export default MetalBuildingsDropdown;
